export default [
  {
    for: 'asset',
    actions: {
      create: true,
      delete: true,
      update: true,
      read: true,
      unlockEntity: true,
      blockEntity: true,
    },
  },
  {
    for: 'asset-format-relation',
    actions: {
      create: true,
      delete: true,
      update: true,
      read: true,
    },
  },
];
